import api from './axios';

export const fetchAnalyticsOverview = async () => (await api.get('/analytics/overview')).data.overview;
export const fetchTicketTrends = async (days = 30) => (await api.get('/analytics/ticket-trends', { params: { days } })).data.trends;
export const fetchCategoryPriority = async () => (await api.get('/analytics/category-priority-stats')).data;
export const fetchSLAStats = async () => (await api.get('/analytics/sla')).data;
export const fetchAgentLeaderboard = async () => (await api.get('/analytics/agent-leaderboard')).data.leaderboard;
export const fetchBotContainment = async () => (await api.get('/analytics/bot-containment')).data;
export const fetchSatisfactionAnalytics = async () => (await api.get('/analytics/satisfaction')).data;
